import { requestApi } from '../../services/HttpRequester';

export function logOut() {
  return requestApi({
    method: 'DELETE',
    url: '/logout'
  });
}
